export default function Values() {
  return (
    <section id="values" className="values">
      <div className="container">
        <header className="section-header">
          <h2>Our Core Values</h2>
          <p>The principles that guide every decision we make and every solution we deliver</p>
        </header>
        <div className="row">

          {/* VALUE 1: Client-First */}
          <div className="col-lg-4" data-aos="fade-up" data-aos-delay="200">
            <div className="box">
              <img
                src="https://images.unsplash.com/photo-1521791136064-7986c2920216?w=400&h=300&fit=crop"
                className="img-fluid"
                alt="Client-first approach"
                style={{ borderRadius: "10px", marginBottom: "15px" }}
              />
              <h3>Client-First Philosophy</h3>
              <p>
                Every project begins with understanding your unique challenges, goals,
                and constraints. We measure our success not by the technology we deploy,
                but by the tangible results it delivers to your business. Your growth is
                our primary objective.
              </p>
            </div>
          </div>

          {/* VALUE 2: Innovation */}
          <div className="col-lg-4 mt-4 mt-lg-0" data-aos="fade-up" data-aos-delay="400">
            <div className="box">
              <img
                src="https://images.unsplash.com/photo-1451187580459-43490279c0fa?w=400&h=300&fit=crop"
                className="img-fluid"
                alt="Continuous innovation"
                style={{ borderRadius: "10px", marginBottom: "15px" }}
              />
              <h3>Relentless Innovation</h3>
              <p>
                Technology never stands still, and neither do we. Our team continuously
                explores emerging tools, frameworks, and methodologies to ensure the
                solutions we build today remain relevant, competitive, and scalable for
                years to come.
              </p>
            </div>
          </div>

          {/* VALUE 3: Transparency */}
          <div className="col-lg-4 mt-4 mt-lg-0" data-aos="fade-up" data-aos-delay="600">
            <div className="box">
              <img
                src="https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&h=300&fit=crop"
                className="img-fluid"
                alt="Transparency and integrity"
                style={{ borderRadius: "10px", marginBottom: "15px" }}
              />
              <h3>Transparency & Integrity</h3>
              <p>
                We believe honest communication builds lasting partnerships. From project
                timelines and budgets to technical limitations and risks, we keep you
                informed at every stage — no surprises, no hidden agendas, just genuine
                collaboration.
              </p>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}